import React from 'react';
import "../style/error.scss";
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';

const Error = () => {
  return (
    <div className='errorContainer'>
        <div className="errorMaindiv">
            <p>404</p>
            <h5>OPS! PAGE NOT FOUND</h5>
            <span>Sorry, the page you're looking for doesn't exist. If you think something is broken, report a problem.</span>
            {/* <img className='errorPic' src="/images/home/errorPic.png" alt="..." /> */}
            <Link className='link' to="/">
            <button className='goBack'>Back To Homepage</button>
        
            </Link>

        </div>
    </div>
  )
}

export default Error;